const sourceOptionsMap = {
    LOCAL: { value: "LOCAL", displayName: "Local" },
    INHERITED: { value: "INHERITED", displayName: "Inherited" },
    PARAMETER: { value: "PARAMETER", displayName: "Parameter" },
};
export const sourceOptions = Object.values(sourceOptionsMap);
